import { makeAutoObservable, } from "mobx";
import { DailyWheelData, IUnusedSpin } from "../interfaces/daily-wheel";

class DailyWheelStore {

  dailyWheelModalIsOpen = false;
  dailyWheelButtonIsVisible = false;
  wheelData: DailyWheelData | null = null;
  lastSpinDate: string | null = null;
  isSpinning: boolean = false;
  unusedSpins: IUnusedSpin[] = [];
  userProgress: number = 0; // Current progress value
  loadingSpinState: boolean = false;
  shouldBounce: boolean = false;
  gameLoadingComplete: boolean = false;
  newFortuneWheelModalShown: boolean = false; // Track if modal has been shown/closed in this session
  forceShowNewFortuneWheelModal: boolean = false; // Allow opening info modal on demand

  constructor() {
    makeAutoObservable(this);
  }

  setIsSpinning(isSpinning: boolean) {
    this.isSpinning = isSpinning;
  }

  setLastSpinDate(value: string | null): void {
    this.lastSpinDate = value;
  }

  setWheelData(data: DailyWheelData) {
    this.wheelData = data;
  }

  setDailyWheelModalIsOpen = (dailyWheelModalIsOpen: boolean) => {
    this.dailyWheelModalIsOpen = dailyWheelModalIsOpen;
  }

  setDailyWheelButtonIsVisible = (dailyWheelButtonIsVisible: boolean) => {
    this.dailyWheelButtonIsVisible = dailyWheelButtonIsVisible;
  }

  setUnusedSpins = (spins: IUnusedSpin[]) => {
    this.unusedSpins = spins;
  }

  setUserProgress = (progress: number) => {
    this.userProgress = progress;
  }

  setLoadingSpinState = (loading: boolean) => {
    this.loadingSpinState = loading;
  }

  // Check if user has unused spins
  hasUnusedSpin = (): boolean => {
    return this.unusedSpins.length > 0;
  }

  setShouldBounce = (shouldBounce: boolean) => {
    this.shouldBounce = shouldBounce;
  }

  // Trigger bounce animation (will auto-stop after delay)
  triggerBounce = () => {
    this.shouldBounce = true;
    // Auto-stop bounce after 10 seconds
    setTimeout(() => {
      this.shouldBounce = false;
    }, 10000);
  }

  setGameLoadingComplete = (complete: boolean) => {
    this.gameLoadingComplete = complete;
  }

  setNewFortuneWheelModalShown = (shown: boolean) => {
    this.newFortuneWheelModalShown = shown;
  }

  setForceShowNewFortuneWheelModal = (forceShow: boolean) => {
    this.forceShowNewFortuneWheelModal = forceShow;
  }

}

export const fortuneWheelStore = new DailyWheelStore();